import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EquivalenciasAcabadosSuperficialesRA } from 'src/app/constants/tablas-utiles';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-equivalencias-acabados-superficiales-ra',
  templateUrl: './equivalencias-acabados-superficiales-ra.page.html',
  styleUrls: ['./equivalencias-acabados-superficiales-ra.page.scss'],
})
export class EquivalenciasAcabadosSuperficialesRaPage implements OnInit {
  public eqvForm:FormGroup = null;
  public equivalenceRa:Array<any> = [];
  public response:string = '';
  previousResult:string = null;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(public services:ServiceService, private formBuilder:FormBuilder) {
    this.eqvForm = this.formBuilder.group({
      unit: ['', Validators.required ],
      size: ['', Validators.required ],
    });
  }

  async ngOnInit() {
    this.equivalenceRa = [...EquivalenciasAcabadosSuperficialesRA];
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  onChangeUnit(ev:any){
    this.eqvForm.controls.size.setValue(undefined);
    // this.response = '';
  }

  reset(){
    this.eqvForm.reset();
    this.response = '';
  }
  isSharing:boolean = false;
  calcular(){
    if(!this.eqvForm.valid)
      return;

    let selected = this.equivalenceRa[this.eqvForm.controls.size.value];
    const unit = this.eqvForm.controls.unit.value;
    this.response = `<br>
    ${ unit==1 ? 'Micrómetros (µm): '+selected.rugosidadValoresRA.micrometers : 'Micropulgadas (µin.): '+selected.rugosidadValoresRA.microinches }<br>
    Rugosidad N Iso Grade Numbers: ${selected.rugosidadNIsoGradeNumbers} <br>
    RMS: ${selected.rms} <br>
    CLA (µin.) Promedio de la línea central: ${selected.cla} <br>
    Rt Rugosidad en Microns: ${selected.rt}`;

    if(this.previousResult != this.response && !this.isSharing){
      this.previousResult = this.response;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }
}
